import { render, staticRenderFns } from "./CanteenRestaurantFormPart.vue?vue&type=template&id=f7b87b44&"
import script from "./CanteenRestaurantFormPart.vue?vue&type=script&lang=js&"
export * from "./CanteenRestaurantFormPart.vue?vue&type=script&lang=js&"
import style0 from "./CanteenRestaurantFormPart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VInput,VRow})
